import * as yup from 'yup';
import moment from 'moment';

export const loginDetailsInitialValues = {
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  lastFourDigitsSSN: '',
};

export const loginDetailsValidation = yup.object().shape({
  firstName: yup.string().required('First Name is required'),

  lastName: yup.string().required('Last Name is required'),

  dateOfBirth: yup.string().test('dateOfBirth', 'Please enter a valid date of birth', value => {
    const parsedDate = moment(value, 'MM/DD/YYYY', true);

    return parsedDate.isValid();
  }),

  lastFourDigitsSSN: yup
    .string()
    .required('SSN is required')
    .matches(/^\d{4}$/, 'Must be 4 digits'),
});
